import React from 'react'

const InvaderIcon = () => {
  return (
    <svg viewBox="167.98 147.62 363.99 264.72">
  <path d="m498.88 313.07v-66.18h-33.09v-33.09h-33.09v-33.09h33.09v-33.09h-66.18v66.18h-99.27v-66.18h-66.18v33.09h33.09v33.09h-33.09v33.09h-33.09v66.18h-33.09v66.18h33.09v-33.09h33.09v66.18h66.18v-33.09h-33.09v-33.09h165.45v33.09h-33.09v33.09h66.18v-66.18h33.09v33.09h33.09v-66.18zm-198.54-33.09h-33.09v-33.09h33.09zm132.36 0h-33.09v-33.09h33.09z"/>
</svg>
  )
}

export default InvaderIcon
